import React, { useEffect, useState } from "react";
import api, { errMsg } from "../../core/api";
import Modal from "../../components/Modal";
import { StatusBadge } from "../../components/Table";
import { useApp } from "../../core/AppContext";
import { fa, formatDate } from "../../core/format";

const TONE = {
  approved: { icon: "fa-solid fa-circle-check", color: "var(--success)", text: "تأیید شد" },
  rejected: { icon: "fa-solid fa-circle-xmark", color: "var(--danger)", text: "رد شد" },
};

export default function LeaveFlowModal({ id, onClose }) {
  const { meta } = useApp();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/requests/${id}/leave-flow`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e)));
  }, [id]);

  return (
    <Modal title="مراحل تأیید مرخصی" onClose={onClose} footer={<button className="btn btn-ghost" onClick={onClose}>بستن</button>}>
      {err && <div className="alert err">{err}</div>}
      {!d && !err && <div className="empty"><div className="spinner" style={{ margin: "0 auto" }} /></div>}
      {d && (
        <>
          <div style={{ marginBottom: 14, lineHeight: 2 }}>
            <b>{d.request.title}</b> <StatusBadge status={d.request.status} label={meta?.requestStatus?.[d.request.status]} />
            <div className="hint">
              درخواست‌دهنده: {d.requesterName} · جانشین: {d.substituteName}
              <br />از {formatDate(d.request.fromDate)} تا {formatDate(d.request.toDate)}
            </div>
          </div>
          <div style={{ display: "grid", gap: 10 }}>
            {d.steps.map((s) => {
              const t = s.decision ? TONE[s.decision] : null;
              const current = !s.decision && d.stage === s.key;
              return (
                <div key={s.key} style={{
                  display: "flex", gap: 12, alignItems: "flex-start", padding: "10px 14px", borderRadius: 12,
                  border: `1.5px solid ${current ? "var(--primary)" : "var(--border)"}`,
                  background: current ? "var(--primary-soft)" : "var(--card)", opacity: !s.decision && !current ? 0.6 : 1,
                }}>
                  <i className={t ? t.icon : current ? "fa-regular fa-clock" : "fa-regular fa-circle"}
                    style={{ color: t ? t.color : "var(--primary)", fontSize: 20, marginTop: 4 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <b>{s.label}</b>{s.who ? <span className="hint"> — {s.who}</span> : null}
                    <div style={{ fontSize: 13, color: t ? t.color : "var(--muted)" }}>
                      {t ? `${t.text}${s.at ? ` · ${formatDate(String(s.at).slice(0, 10))}` : ""}` : current ? "در انتظار بررسی" : "هنوز به این مرحله نرسیده"}
                    </div>
                    {s.note && <div style={{ marginTop: 4, whiteSpace: "pre-wrap", lineHeight: 1.9 }}>{s.note}</div>}
                  </div>
                </div>
              );
            })}
          </div>
          {d.stage === "approved" && (
            <div className="alert ok" style={{ marginTop: 12 }}>
              {d.shiftsMoved + d.shiftsRemoved > 0
                ? `شیفت ${fa(d.shiftsMoved + d.shiftsRemoved)} روز از برنامه‌ی درخواست‌دهنده به جانشین منتقل شد.`
                : "در بازه‌ی مرخصی شیفتی برای درخواست‌دهنده ثبت نبود."}
            </div>
          )}
        </>
      )}
    </Modal>
  );
}